<template>
    <div class="uploader">
        <div class="file-upload">
            <v-btn
                color="primary"
                block
                tile
                depressed
                :disabled="!enabled"
                :loading="isSelecting"
                @click="handleFileImport"
            >
                {{ buttonText }}
            </v-btn>
            <input ref="uploader" type="file" @change="onFileChange" :id="'file-input' + id" accept=".zip" style="display: none">
        </div>
        <!-- <div v-if="errorMsg != ''" class="uploader-error">
            <p>{{errorMsg}}</p>
            <v-btn>X</v-btn>
        </div> -->
    </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      selectedFile: '',
      isSelecting: false,
      progress: 0,
      unitId: this.$unit.uuid,
      fileId: -1,
      errorMsg: '',
      defaultButtonText: 'ZIP-Datei Hochladen'
    }
  },
  props: ['id', 'document', 'enabled'],
  computed: {
    buttonText () {
      if (this.selectedFile) {
        if (this.progress !== 0) {
          return this.progress
        } else {
          // return this.selectedFile.name
          return this.defaultButtonText
        }
      } else {
        return this.defaultButtonText
      }
    }
  },
  methods: {
    handleFileImport () {
      this.isSelecting = true

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })

      // Trigger click on the FileInput
      this.$refs.uploader.click()
    },
    onFileChange (e) {
      const selectedFile = e.target.files[0]
      this.selectedFile = selectedFile
      this.progress = 0
      this.errorMsg = ''
      this.onUploadFile()
    },
    onDragFile (e) {
      this.selectedFile = e.dataTransfer.files
    },
    onUploadFile () {
      const formData = new FormData()
      formData.append('document', this.document)
      formData.append('file', this.selectedFile)
      formData.append('unitId', this.unitId)

      axios
        .post(`${process.env.API_URL}/upload`, formData, {
          headers: {
            'Authorization': `Bearer ${localStorage.accessToken}`
          },
          onUploadProgress: ProgressEvent => {
            let progress = Math.round((ProgressEvent.loaded / ProgressEvent.total) * 100) + '%'
            this.progress = progress
          }
        })
        .then(res => {
          // console.log(res)
          this.fileId = res.data.id
          this.progress = 0
          this.$emit('updatefileid', this.fileId)
        })
        .catch(err => {
          console.log(err)
          this.errorMsg = err.response.data.msg
          this.$emit('uploaderError', err.response.data.msg)
          this.progress = 0
        })
    }
  }
}
</script>
<style scoped>
.uploader-error {
  color: red;
  background-color: unset;
}
.uploader {
  height: 100%;
}
#file-input {
    display: none;
}
#upload-label {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}
.file-drop-area {
    /* position: absolute; */
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    /* background: gray; */
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue